import { render, staticRenderFns } from "./alla-ovningar.vue?vue&type=template&id=7a6d40a0&scoped=true"
import script from "./alla-ovningar.vue?vue&type=script&lang=js"
export * from "./alla-ovningar.vue?vue&type=script&lang=js"
import style0 from "./alla-ovningar.vue?vue&type=style&index=0&id=7a6d40a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6d40a0",
  null
  
)

export default component.exports